document.addEventListener('DOMContentLoaded', function() {

var element = document.querySelector('.notify-me-button');

// Check if the element exists
if (element) {
  // Set the id attribute to the same value as the class name
  element.id = 'notifyMeButton';
}
});
